var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 221,
    viewBox: "0 0 134 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0433 220.182H0.36565L0 66.2542V55.3227C0 24.7677 27.0581 0 60.4183 0H134V164.837C134 195.281 107.157 219.983 73.9258 220.16H69.0433V220.182Z",
    fill: "#004757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0928 205.525C40.4597 205.525 47.7297 197.188 47.7297 186.9V75.6777C39.3628 75.6777 32.0928 84.0149 32.0928 94.3034V205.525Z",
    fill: "#FF5E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1699 170.846C67.5369 170.846 74.8068 162.509 74.8068 152.176V115.08C66.4399 115.08 59.1699 123.417 59.1699 133.706V170.868V170.846Z",
    fill: "#14CCB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.908 111.31C93.541 111.31 86.271 119.647 86.271 129.936V146.765C94.6379 146.765 101.908 135.435 101.908 125.146V111.31Z",
    fill: "#C8EEED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1699 107.719C67.5369 107.719 74.8068 99.3821 74.8068 89.0493V51.9531C66.4399 51.9531 59.1699 60.2903 59.1699 70.5788V107.741V107.719Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.908 70.8892C93.541 70.8892 86.271 79.2264 86.271 89.5148V106.344C94.6379 106.344 101.908 95.0138 101.908 84.7254V70.8892Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.908 28.6475C93.541 28.6475 86.271 36.9847 86.271 47.2731V64.1028C94.6379 64.1028 101.908 52.7721 101.908 42.4837V28.6475Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader2);
export default __webpack_public_path__ + "static/media/loader-2.fbb5bde38875269b80c15b04fb5e1c45.svg";
export { ForwardRef as ReactComponent };